// import React, { useEffect, useState } from "react";
// import { Card, Form, Button, Row, Col } from "react-bootstrap";
// import '../../assets/css/FilterSection.css'

// const FilterSection = ({ filters, onFilterChange, onClearFilters,tourSectorDetails,selectedPriceRange,setSelectedPriceRange ,getPriceRangeFromTours}) => {
//   console.log("test=-==",tourSectorDetails)
//   // State for tracking selected filter options
//   const [durationValue, setDurationValue] = useState(0);

//   // Handler for price range filter
//   const handlePriceRangeClick = (min, max) => {
//     const priceRange = { min, max };
//     setSelectedPriceRange(priceRange);
//     onFilterChange("priceRange", priceRange);
//   };

//   const dayValues =  tourSectorDetails?.tour_duration?.map(item => parseInt(item?.no_days, 10)) || [];
//   const min = 1;
//   const max = Math?.max(...dayValues) || 10;

//   useEffect(() => {
//     setDurationValue(max); // Default to min value
//   }, [max]);

//   const handleDurationChange = (e) => {
//     const value = parseInt(e.target.value, 10);
//     setDurationValue(value);
//     handleDurationButtonClick(0, value);
//   };

//   // // Handler for duration slider
//   // const handleDurationChange = (e) => {
//   //   const value = parseInt(e.target.value);
//   //   console.log("asdsad",value)
//   //   setDurationValue(value);

//   //   handleDurationButtonClick(0, value)
//   //   // We don't apply the filter instantly on slider move
//   // };

//   // Handler for duration preset buttons
//   const handleDurationButtonClick = (min, max) => {
//     const durationRange = { min, max };
//     onFilterChange("duration", durationRange);
//   };

//   // Handler for date range filters
//   const handleDateChange = (type, e) => {
//     const value = e.target.value;
//     onFilterChange("departureDates", {
//       ...filters.departureDates,
//       [type]: value,
//     });
//   };

//   // Handler for checkbox filters (cities, package types, specialties)
//   const handleCheckboxChange = (filterType, value, isChecked) => {
//     let currentValues = [...(filters[filterType] || [])];

//     if (isChecked) {
//       // Add value if checked
//       if (!currentValues.includes(value)) {
//         currentValues.push(value);
//       }
//     } else {
//       // Remove value if unchecked
//       currentValues = currentValues.filter((item) => item !== value);
//     }

//     onFilterChange(filterType, currentValues);
//   };


// const uniquePriceRanges = getPriceRangeFromTours(tourSectorDetails?.tour_package || []);
//   console.log("asdsad123213213",uniquePriceRanges,tourSectorDetails?.tour_price)

//   return (
//     <Card className="filter-section">
//       <Card.Header className="filter-header">
//         <h5 style={{color:"#fff"}}>Refine Your Journey</h5>
//         <Button variant="link" className="clear-btn"  style={{color:"#fff"}} onClick={onClearFilters}>
//           Clear All
//         </Button>
//       </Card.Header>

//       <Card.Body>
        
//         {/* Price Range */}
//        {/* {tourSectorDetails.tour_package?.[0]?.type !== "fit" && ( */}
//         <div className="mb-4">
//           <h5>Price Range</h5>
//           <div className="d-flex flex-wrap">
//  {uniquePriceRanges?.map(({ min, max }, index) => (
//         <Button
//           key={index}
//           variant={selectedPriceRange?.min === min ? "primary" : "outline-primary"}
//           className="me-2 mb-2 price-filter"
//           onClick={() => handlePriceRangeClick(min, max)}
//         >
//           ₹{(min / 1000).toFixed(0)}K - ₹{(max / 1000).toFixed(0)}K
//         </Button>
//       ))}

//           </div>
//         </div>
//        {/* )} */}
//         {/* Tour Duration */}
//         <div className="mb-4">
//           <h5>Tour Duration</h5>
//    <Form.Range
//       min={1}
//       max={max}
//       value={durationValue}
//       onChange={handleDurationChange}
//       className="duration-filter"
//     />
   
//           <div className="d-flex justify-content-between mt-2 mb-2">
//             <span>1 days</span>
//             <span>{max} days</span>
//           </div>
//  <div style={{ marginTop: '8px', fontWeight: '500' }}>
//         Selected days {`( 1 to ${durationValue} )`}
//       </div>

 
//         </div>

//         <div className="mb-4">
//           <h5>Package Type</h5>


//           {tourSectorDetails?.tour_package_type?.map((category) => (
//   <Form.Check
//     key={category.tour_category_id}
//     type="checkbox"
//     id={category.tour_category_id}
//     label={`${category.name}`}
//     onChange={(e) =>
//       handleCheckboxChange(
//         "packageTypes",
//         category.name,
//         e.target.checked
//       )
//     }
//     checked={filters.packageTypes?.includes(category.name)}
//     className="mb-2"
//   />
// ))}

//         </div>

//       </Card.Body>
//     </Card>
//   );
// };

// export default FilterSection;

import React, { useEffect, useState } from "react";
import { Card, Form, Button, Badge } from "react-bootstrap";
import { FaFilter, FaHistory, FaCalendarAlt, FaRupeeSign, FaCity } from "react-icons/fa";

const FilterSection = ({ 
  filters, 
  onFilterChange, 
  onClearFilters, 
  tourSectorDetails, 
  selectedPriceRange, 
  setSelectedPriceRange, 
  getPriceRangeFromTours 
}) => {
  const [durationValue, setDurationValue] = useState(0);

  const dayValues = tourSectorDetails?.tour_duration?.map(item => parseInt(item?.no_days, 10)) || [];
  const minDays = 1;
  const maxDays = Math.max(...dayValues, 10);

  useEffect(() => {
    setDurationValue(maxDays);
  }, [maxDays]);

  const handlePriceRangeClick = (min, max) => {
    const priceRange = { min, max };
    setSelectedPriceRange(priceRange);
    onFilterChange("priceRange", priceRange);
  };

  const handleDurationChange = (e) => {
    const value = parseInt(e.target.value, 10);
    setDurationValue(value);
    onFilterChange("duration", { min: 0, max: value });
  };

  const handleCheckboxChange = (filterType, value, isChecked) => {
    let currentValues = [...(filters[filterType] || [])];
    if (isChecked) {
      if (!currentValues.includes(value)) currentValues.push(value);
    } else {
      currentValues = currentValues.filter((item) => item !== value);
    }
    onFilterChange(filterType, currentValues);
  };

  const uniquePriceRanges = getPriceRangeFromTours(tourSectorDetails?.tour_package || []);

  const styles = {
    card: {
      border: 'none',
      borderRadius: '15px',
      boxShadow: '0 8px 25px rgba(0,0,0,0.08)',
      position: 'sticky',
      top: '100px',
      maxHeight: 'calc(100vh - 120px)', // Prevents card from going off screen
      display: 'flex',
      flexDirection: 'column'
    },
    header: {
      background: '#0a3b78',
      color: '#fff',
      border: 'none',
      padding: '12px 18px', // Reduced padding
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexShrink: 0
    },
    sectionTitle: {
      fontSize: '0.95rem', // Smaller title
      fontWeight: '700',
      marginBottom: '10px',
      display: 'flex',
      alignItems: 'center',
      color: '#2c3e50'
    },
    priceBadge: {
      cursor: 'pointer',
      padding: '6px 10px', // Smaller chips
      borderRadius: '8px',
      transition: 'all 0.2s ease',
      border: '1px solid #eee',
      fontSize: '0.75rem',
      fontWeight: '600'
    },
    scrollArea: {
      maxHeight: '180px', // Limits height of long lists
      overflowY: 'auto',
      paddingRight: '5px'
    }
  };

  return (
    <Card style={styles.card}>
      <Card.Header style={styles.header}>
        <div className="d-flex align-items-center">
          <FaFilter className="me-2" size={14} />
          <h6 className="mb-0 fw-bold">Filters</h6>
        </div>
        <Button 
          variant="link" 
          onClick={onClearFilters}
          className="p-0 text-white text-decoration-none extra-small opacity-75"
          style={{ fontSize: '0.75rem' }}
        >
          <FaHistory className="me-1" /> Reset
        </Button>
      </Card.Header>

      <Card.Body className="p-3" style={{ overflowY: 'auto' }}>
        
        {/* 1. Price Range Chips */}
        <div className="mb-4">
          <h6 style={styles.sectionTitle}>
            <FaRupeeSign className="me-2 text-danger" size={14} /> Price
          </h6>
          <div className="d-flex flex-wrap gap-1">
            {uniquePriceRanges?.map(({ min, max }, index) => {
              const isActive = selectedPriceRange?.min === min;
              return (
                <div
                  key={index}
                  onClick={() => handlePriceRangeClick(min, max)}
                  style={{
                    ...styles.priceBadge,
                    backgroundColor: isActive ? '#8f0909' : '#f8f9fa',
                    color: isActive ? '#fff' : '#555',
                    borderColor: isActive ? '#8f0909' : '#eee',
                  }}
                >
                  ₹{(min / 1000).toFixed(0)}K - ₹{(max / 1000).toFixed(0)}K
                </div>
              );
            })}
          </div>
        </div>

        {/* 2. Duration Slider */}
        <div className="mb-4">
          <h6 style={styles.sectionTitle}>
            <FaCalendarAlt className="me-2 text-danger" size={14} /> Duration
          </h6>
          <div className="px-1">
            <Form.Range
              min={minDays}
              max={maxDays}
              value={durationValue}
              onChange={handleDurationChange}
              className="custom-range-sm"
            />
            <div className="d-flex justify-content-between mt-2">
              <span className="text-muted small">1 Day</span>
              <span className="fw-bold text-danger small">{durationValue} Days</span>
              <span className="text-muted small">{maxDays} Days</span>
            </div>
          </div>
        </div>

        {/* 3. Category */}
        <div className="mb-4">
          <h6 style={styles.sectionTitle}>
            <FaFilter className="me-2 text-danger" size={14} /> Category
          </h6>
          <div style={styles.scrollArea} className="custom-scrollbar">
            {tourSectorDetails?.tour_package_type?.map((category) => (
              <div key={category.tour_category_id} className="custom-check-sm mb-1 ms-1">
                <Form.Check
                  type="checkbox"
                  id={`cat-${category.tour_category_id}`}
                  label={category.name}
                  style={{ fontSize: '0.85rem' }}
                  onChange={(e) => handleCheckboxChange("packageTypes", category.name, e.target.checked)}
                  checked={filters.packageTypes?.includes(category.name)}
                />
              </div>
            ))}
          </div>
        </div>

        {/* 4. City */}
        <div className="mb-2">
          <h6 style={styles.sectionTitle}>
            <FaCity className="me-2 text-danger" size={14} /> City
          </h6>
          <div style={styles.scrollArea} className="custom-scrollbar">
            {tourSectorDetails?.cities?.map((city) => (
              <div key={city} className="custom-check-sm mb-1 ms-1">
                <Form.Check
                  type="checkbox"
                  id={`city-${city}`}
                  label={city}
                  style={{ fontSize: '0.85rem' }}
                  onChange={(e) => handleCheckboxChange("cities", city, e.target.checked)}
                  checked={filters.cities?.includes(city)}
                />
              </div>
            ))}
          </div>
        </div>
      </Card.Body>

      <style>{`
        .custom-range-sm::-webkit-slider-thumb {
          background: #8f0909;
          height: 16px;
          width: 16px;
          border: 2px solid #fff;
          border-radius: 50%;
          cursor: pointer;
          margin-top: -4px;
        }
        .custom-range-sm::-webkit-slider-runnable-track {
          background: #e9ecef;
          height: 6px;
          border-radius: 3px;
        }
        .custom-check-sm .form-check-input {
          width: 0.9em;
          height: 0.9em;
          cursor: pointer;
        }
        .custom-check-sm .form-check-label {
          cursor: pointer;
          color: #444;
        }
        /* Tiny Scrollbar */
        .custom-scrollbar::-webkit-scrollbar {
          width: 4px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: #f1f1f1;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #ccc;
          border-radius: 10px;
        }
      `}</style>
    </Card>
  );
};

export default FilterSection;